import { render, staticRenderFns } from "./by-phone.vue?vue&type=template&id=23517c0a"
import script from "./by-phone.vue?vue&type=script&lang=js"
export * from "./by-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-phone.vue
// module id = nW42
// module chunks = 0